import { ArrowRight, MessageSquarePlus } from 'lucide-react'

export interface ActiveSessionBannerProps {
  /** Id de la sesión activa más reciente del mismo contacto. */
  activeConversationId: string
  onGoToActive: (conversationId: string) => void
}

/**
 * A) Enlace de sesión activa: cuando el vendedor abre una conversación cerrada
 * cuyo cliente ya re-enganchó en una sesión nueva, este banner lo dirige a la
 * sesión activa en lugar de invitarlo a "reabrir" la anterior (reabrir crearía
 * dos conversaciones abiertas simultáneas para el mismo contacto).
 */
export function ActiveSessionBanner({ activeConversationId, onGoToActive }: ActiveSessionBannerProps) {
  return (
    <div
      role="status"
      aria-live="polite"
      className="flex flex-col sm:flex-row sm:items-center gap-3 border border-emerald-200 bg-emerald-50 px-4 py-3 rounded-lg"
    >
      <MessageSquarePlus className="h-5 w-5 shrink-0 text-emerald-600" aria-hidden="true" />
      <p className="flex-1 text-sm text-emerald-900">
        El cliente ha iniciado una <strong>nueva conversación activa</strong>. Esta sesión anterior está cerrada;
        continúa la atención en la sesión nueva.
      </p>
      <button
        type="button"
        onClick={() => onGoToActive(activeConversationId)}
        className="inline-flex items-center justify-center gap-1.5 rounded-md bg-emerald-600 px-3 py-1.5 text-sm font-medium text-white transition-colors hover:bg-emerald-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-emerald-500 focus-visible:ring-offset-2"
      >
        Ir a la conversación activa
        <ArrowRight className="h-4 w-4" aria-hidden="true" />
      </button>
    </div>
  )
}
